// English translations
export default {
  'general.logout': 'Logout',
  'general.sessionExpired': 'Your session has expired. Please log in again.',
  'general.error': 'Something went wrong.',
  'general.tryAgain': 'Please try again later',
  'general.login': 'Login',
  'login.welcome': 'Welcome to Piction.',
  'login.loginMessage': ' Please log in.',
  'general.reLogin': 'Please log in again.',
  'general.loginCode': 'Please enter authentication code',
  'general.language': 'Language',
  'general.language.english': 'English',
  'general.language.french': 'French',
  'general.language.german': 'German',
  'general.scrollToTop': 'Scroll To Top',
  'general.fillMandatory': 'Please Fill All Mandatory Values',
  'general.invalidEmail': 'Invalid Email Address',
  'general.select': 'Select',
  'general.cancel': 'Cancel',
  'general.add': 'Add',
  'general.remove': 'Remove',
  'general.save': 'Save',
  'general.create': 'Create',
  'general.delete': 'Delete',
  'general.update': 'Update',
  'general.close': 'Close',
  'general.download': 'Download',

  'umoMediaView.previewUnavailable': 'Preview unavailable.',
  'umoThumbnail.sensitiveContentLabel': 'Sensitive Content',

  'login.invalidCode': '',
  'login.codeRegistryRequired':
    'Two-Factor Authentication is required for your account',
  'login.codeRegistryMsg': 'Please register with the following QR code',
  'login.codeDisplayOnceWarning':
    'Please note: The QR code will only appear once',
  'login.scanToLinkMsg':
    'Scan the QR code to link your account with a two-factor authentication app',
  'login.registerBtn': 'Register',

  'searchResults.sortBy': 'Sort by',
  'searchResults.sortByNone': 'None',
  'searchResults.sortManually': 'Manually Sort Media',
  'searchResults.noItemFound': 'No Items Found!',

  'searchResults.filter': 'Filter',
  'searchResults.filter.date': 'Date',
  'searchResults.filter.date.from': 'From',
  'searchResults.filter.date.to': 'To',
  'searchResults.filter.date.all': 'ALL',
  'searchResults.filter.applyFiltersButton': 'Apply Filters',

  'searchResults.options': 'Options',
  'searchResults.options.selection': 'Selection',
  'searchResults.options.selection.selectPage': 'Select All On Page',
  'searchResults.options.selection.selectSearch': 'Select All Results',
  'searchResults.options.selection.deselectAll': 'Deselect All',
  'searchResults.options.selection.bulkEdit': 'Bulk Edit',
  'searchResults.options.actions': 'Actions',
  'searchResults.options.actionsWorkspaceTitle': 'Workspace Actions',
  'searchResults.options.actions.addToWorkspace': 'Add to {workspaceName}',
  'searchResults.options.actions.addToWorkspace.default': 'workspace',
  'searchResults.options.actions.removeSelectedFromWorkspace':
    'Remove Selected from Workspace',
  'searchResults.options.actions.exportAllToExcel':
    'Export {selectCount, plural, =0 {All} other {Selected}} to Excel (All Tags)',
  'searchResults.options.actions.exportTagsToExcel':
    'Export {selectCount, plural, =0 {All} other {Selected}} to Excel (Selected Tags)',
  'searchResults.options.actions.exportToPPT':
    'Export {selectCount, plural, =0 {All} other {Selected}} to PPT',
  'searchResults.options.actions.exportToZip':
    'Export {selectCount, plural, =0 {All} other {Selected}} to ZIP',
  'searchResults.options.actions.exportToPDF':
    'Export {selectCount, plural, =0 {All} other {Selected}} to PDF',
  'searchResults.options.actions.batchDownload': 'Download All Workspace Items',
  'searchResults.options.actions.emailAll': 'Email All',
  'searchResults.options.actions.relateAllInWorkspace':
    'Relate all items in Workspace',
  'searchResults.options.actions.umosExpectedError':
    'Error retrieving Items data',
  'searchResults.options.actions.noUMOsSelected': 'No Items Found',
  'searchResults.options.actions.shareAsPortal': 'Share as Portal',
  'searchResults.options.actions.shareExternalPortal':
    'Share as External Portal',
  'searchResults.options.actions.saveToDropbox':
    'Save {selectCount, plural, =0 {All} other {Selected}} to Dropbox',
  'searchResults.options.actions.resize':
    'Resize {selectCount, plural, =0 {All} other {Selected}}',
  'searchResults.options.actions.dropboxSaveSuccess':
    'Success! Files saved to your Dropbox',
  'searchResults.options.actions.dropboxSaveError':
    'An error occurred while saving your files to Dropbox',
  'searchResults.options.actions.tooManyItems':
    'a maximum of {maxItems} items can be selected for the {templateName}',
  'searchResults.compare': 'Compare',
  'searchResults.copy': 'Copy',
  'searchResults.copy-screen.overlayMessageCategory':
    'Select Destination Category',
  'searchResults.copy-screen.overlayMessageWorkspace':
    'Select Destination Workspace',
  'searchResults.copy-screen.overlayMessageCancel': 'Press ESC to cancel',
  'searchResults.download.tooManyItems':
    'Unable to download more than {maxItems} items',
  'searchResults.download.selectAnyItem': 'Select items to download',

  'searchResults.loadingHeader': 'Loading...',
  'searchResults.previousSearch': 'Back to:',
  'searchResults.previousSearchAdv': 'Advanced Search',
  'searchResults.objectsFoundHeader':
    '{objectsFoundCount} {objectsFoundCount, plural, one {item} other {items}} found',
  'searchResults.objectSelected':
    '{objectsSelectedCount} {objectsSelectedCount, plural, one {item} other {items}} selected',

  'categoryDialog.editHeader': 'Edit Category',
  'categoryDialog.saveButton': 'Save',
  'categoryDialog.createChildHeader': 'Add Sub-Category',
  'categoryDialog.createButton': 'Create',
  'categoryDialog.addHeader': 'Add Category',
  'categoryDialog.namePlaceholder': 'Enter Category Name',
  'categoryDialog.deleteCheckbox': 'Delete this category',
  'categoryDialog.deleteButton': 'Delete',
  'categoryDialog.deleteInProgress': 'Category delete in progress',
  'categoryDialog.deleteSuccess': 'Category deleted Successfully',

  'categoryMoveDialog.successMoveMessage': 'Move Successful',
  'categoryMoveDialog.InProgressMoveMessage': 'Move In Progress',
  'categoryMoveDialog.successCopyMessage': 'Copy Successful',
  'categoryMoveDialog.InProgressCopyMessage': 'Copy In Progress',
  'categoryMoveDialog.moveHeader': 'Move Category',
  'categoryMoveDialog.moveSubtext':
    'Select the new parent for "{categoryName}".',
  'categoryMoveDialog.cancelButton': 'Cancel',
  'categoryMoveDialog.moveButton': 'Move',

  'messageDialog.dismissAllButton': 'Close',

  'metaAttach.attachButton': 'Attach metadata',
  'metaAttach.replaceCheckbox': 'Replace existing values',
  'metaAttach.defaultAttachBehavior': 'Default: Append to existing values',
  'metaAttach.attachArea':
    'Attach the metadata to selected items by dragging items here\n\n\nOR',
  'metaAttach.umosExpectedError': 'Expected UMOs to be found',
  'metaAttach.genericPartialError':
    'There was at least one error while performing metadata attach. Please try again.',
  'metaAttach.currentValues': 'Current Values',
  'metaAttach.editCurValues': 'Edit Meta Values',
  'metaAttach.PopulateButton': 'Populate',
  'metaAttach.RelationshipDesc': 'Relationship Description',
  'metaAttach.metaPopulateDragDrop':
    'Add the selected item IDs to the "{tagName}" metatag by\n\nDragging the items here\n\nOR',
  'metaAttach.populateMetatagDoesntExist':
    'a metatag of type "UMO Insert Group" could not be found.',
  'metaAttach.metaCopyDragDrop':
    'Copy metadata from {umoName} to the selected items by\n\nDragging the items here\n\nOR',
  'metaAttach.maxResultsError':
    'A max of {maxItems} items can be copied at a time.',
  'metaPanel.title': 'Meta Panel:',

  'navOptions.setsHeader': 'CURATED SETS',
  'navOptions.workspaceHeader': 'WORKSPACES',
  'navOptions.categoryHeader': 'CATEGORIES',
  'navOptions.adminHeader': 'ADMIN',
  'navOptions.homeHeader': 'HOME',
  'navOptions.formsHeader': 'FORMS',
  'navOptions.thesaurusHeader': 'THESAURUS',
  'navOptions.reportsHeader': 'REPORTS',

  'navAdminPanel.metaAttach': 'Metadata Attach',
  'navAdminPanel.manageUsers': 'Manage Users',
  'navAdminPanel.usersAndRoles': 'Users and Roles',
  'navAdminPanel.adminHeader': 'Admin',
  'navAdminPanel.manageCategoryRoles': 'Category Roles Manager',
  'navAdminPanel.publishBtn': 'Publish Media',
  'navAdminPanel.createRelationalBtn': 'Add New Record',
  'navAdminPanel.manageLoader': 'Manage Loader',
  'navAdminPanel.importMetadata': 'Import Metadata',
  'navAdminPanel.recycleBin': 'Recycle Bin',

  'navReportsPanel.editHistory': 'Edit History',
  'navReportsPanel.RecordHeader': 'Reports',
  'navReportsPanel.umoID': 'UMO ID',
  'navReportsPanel.categoryID': 'Category ID',
  'navReportsPanel.date': 'Date',
  'navReportsPanel.user': 'User',
  'navReportsPanel.tagName': 'Tag Name',
  'navReportsPanel.change': 'Change',
  'navReportsPanel.submit': 'Submit',
  'navReportsPanel.downloadCSV': 'Download CSV',
  'navReportsPanel.dateFrom': 'Date From',
  'navReportsPanel.dateTo': 'Date To',
  'navReportsPanel.enterUMOID': 'Enter UMO ID',
  'navReportsPanel.downloadList': 'Download List',
  'navReportsPanel.type': 'Type',
  'navReportsPanel.filename': 'Filename',

  'adminPurge.purgeConfirmationTitle': 'Empty Recycle Bin',
  'adminPurge.purgeConfirmationButton': 'Empty',
  'adminPurge.purgeConfirmMessage':
    'Are you sure you want to permanently delete all items in the Recycle Bin? This action cannot be undone.',
  'adminPurge.purgeFailed': 'An error occurred while purging the recycle bin',
  'adminPurge.purgeSuccess': 'Recycle Bin emptied successfully',

  'adminPublish.publishTitle': 'Publish Media',
  'adminPublish.publishBtn': 'START',
  'adminPublish.publishBtnTitle':
    'Are You Sure You Want To Start The Synchronization Process?',
  'adminPublish.publishBtnStart': 'Initiate synchronization',
  'adminPublish.publishBtnCancel': 'Cancel',
  'adminPublish.publishProc.Success':
    'Synchronization Process Successfully Started',
  'adminPublish.publishProc.Fail':
    'An Error Occurred While Pushing Media To Portal',
  'adminPublish.publishProc.EmptyQueue':
    'Nothing in Queue. All assets are already published',
  'adminPublish.publishSubTitle':
    'This will publish all assets tagged accordingly to the portal',

  'navCategoryPanel.workspaceToCategoryError':
    'You cannot move workspace items into a category',
  'navCategoryPanel.noEditRoleError':
    'You do not have permission to move or copy items into this category',
  'navCategoryPanel.noMoveRoleError':
    'You do not have permission to move items from the current category',
  'navCategoryPanel.categoryHeader': 'Categories',
  'navCategoryPanel.createGlobalCategoryBtn': 'Add Global Category',
  'navCategoryPanel.addCategoryButton': 'Add Category',
  'navCategoryPanel.menuAddChild': 'Add Sub-Category',
  'navCategoryPanel.menuUploadToChild': 'Upload',
  'navCategoryPanel.menuBulkEditChild': 'Bulk Edit',
  'navCategoryPanel.menuEditChild': 'Edit',
  'navCategoryPanel.menuMoveChild': 'Move',
  'navCategoryPanel.menuSortChild': 'Sort Items',

  'navFormsPanel.formHeader': 'Forms',

  'navWorkspacePanel.workspaceHeader': 'Workspaces',
  'navWorkspacePanel.addWorkspaceButton': 'Add Workspace',
  'navWorkspacePanel.menuAddChild': 'Add Sub-Space',
  'navWorkspacePanel.menuEditChild': 'Edit',

  'navHighlightsPanel.highlightsHeader': 'Curated Sets',
  'navHighlightsPanel.addSetButton': 'Add Curated Set',
  'navHighlightsPanel.menuEditChild': 'Edit',

  'navThesaurusPanel.thesaurusHeader': 'Thesaurus',
  'navThesaurusPanel.addTermButton': 'Add Term',
  'navThesaurusPanel.menuEditChild': 'Edit',
  'navThesaurusPanel.attachSuccessful': 'Successfully Added',

  'thesaurusDialog.editHeader': 'Edit Term',
  'thesaurusDialog.saveButton': 'Save',
  'thesaurusDialog.createChildHeader': 'Add Sub-Term',
  'thesaurusDialog.createButton': 'Create',
  'thesaurusDialog.addHeader': 'Add Term',
  'thesaurusDialog.namePlaceholder': 'Enter Term Name',
  'thesaurusDialog.deleteCheckbox': 'Delete This Term',
  'thesaurusDialog.deleteButton': 'Delete',
  'thesaurusDialog.deleteInProgress': 'Delete In Progress',
  'thesaurusDialog.deleteSuccess': 'Term Deleted Successfully',

  'pagination.previousButton': 'Previous',
  'pagination.pageNumberOfTotal': 'of {pageTotal}', // i.e "2 of 3"
  'pagination.nextButton': 'Next',

  'panelTree.noItemsMessage': 'No items to show',

  'searchBar.defaultSearch': 'Simple search',
  'searchBar.advancedSearch': 'Advanced Search',
  'searchBar.advancedButton': 'ADVANCED',
  'searchBar.advanced.selectMetadataLabel': 'Select Metadata Group',
  'searchBar.advanced.selectCollectionLabel': 'Select Collection or Category',
  'searchBar.advanced.availableSchemas': 'Select Metadata Schemas',
  'searchBar.advanced.selectAllSchemas': 'SELECT ALL',
  'searchBar.advanced.collectionsRetrieveError':
    'Error retrieving collections; click to retry',
  'searchBar.advanced.mediaType': 'Media Type',
  'searchBar.advanced.addMetatagButton': 'Add Metatag',
  'searchBar.advanced.searchButton': 'Search',
  'searchBar.advanced.clearButton': 'Clear',
  'searchBar.advancedForm.operatorAnd': 'AND',
  'searchBar.advancedForm.operatorOr': 'OR',
  'searchBar.advancedForm.operatorNot': 'NOT',
  'searchBar.advancedForm.anyMetatagOption': 'Any metatag',
  'searchBar.advancedForm.searchContainS': 'Contains',
  'searchBar.advancedForm.searchNotContain': 'Does not contain',
  'searchBar.advancedForm.searchStartsWith': 'Starts with',
  'searchBar.advancedForm.searchEndsWith': 'Ends with',
  'searchBar.advancedForm.searchTermPlaceholder': 'Search term',
  'searchBar.advanced.newSearchName': 'New Search Name',
  'searchBar.advanced.saveSearchButton': 'Save & Search',
  'searchBar.advanced.savedSearches': 'Your Saved Searches',
  'searchBar.advanced.searchQuery': 'Search Query',
  'searchBar.advanced.searchNameMissing': 'Search Name Missing',
  'searchBar.advanced.searchSaveError':
    'An error occurred while trying to save your search',
  'searchBar.advanced.deleteSearchButton': 'Delete {searchName}',
  'searchBar.advanced.saveSearchExists': 'Name already exists',
  'searchBar.advanced.specificCollection': 'Search Current Collection Only',
  'searchBar.advanced.selectToStart': 'Please select a Saved Search, Collection or Category to begin.',
  'searchBar.advanced.enableCategoryFilter': 'Search selected categories only',
  'searchBar.advancedForm.helpTooltip.content':
    'for {numberText} and {dateText} fields, use:{br}'
    + '{rangeExample} - search for results within a range{br}'
    + '{lessExample} - search results with a minimum value{br}'
    + '{greaterExample} - search results with a maximum value{br}'
    + '{br} EXAMPLES:{br} {example1}{br} {example2}{br} {example3}{br} {example4}',

  'searchBar.simple.searchPlaceholder': 'Search',
  'searchBar.simple.typeAny': 'Any',
  'searchBar.simple.typeImage': 'Image',
  'searchBar.simple.typeVideo': 'Video',
  'searchBar.simple.typeAudio': 'Audio',
  'searchBar.simple.typeDocument': 'Document',
  'searchBar.simple.typeRecord': 'Record',

  'umoDetailView.requestUMOError': 'No UMO returned',
  'umoDetailView.primaryImageLabel': 'This is the primary image.',
  'umoDetailView.setAsPrimaryButton': 'Set this image as the primary image.',
  'umoDetailView.setAsPrimaryWarningMessage':
    'Are you sure you want to set this image as primary?',
  'umoDetailView.addToWorkspaceButton': 'Add to {workspaceName}',
  'umoDetailView.addToWorkspaceGenericButton': 'Add to Workspace',
  'umoDetailView.DownloadImageButton': 'Download',
  'umoDetailView.DownloadViewedImageTooltip': 'Download displayed image',
  'umoDetailView.metadataHeader': 'Metadata',
  'umoDetailView.relatedItemHeader': 'Related Items:',
  'umoDetailView.loadingModel':
    'Loading Model, this could take some time. Please wait.',
  'umoDetailView.renderingModel': 'Rendering Model. Please wait.',
  'umoDetailView.metadataLanguageTooltip': 'View in another language',

  'umoCardView.save': 'Save',
  'umoCardView.dueDate': 'Due Date',
  'umoCardView.status': 'Status',
  'umoCardView.delete': 'Delete',
  'umoCardView.deleteCard': 'Delete Card',
  'umoCardView.newComment': 'New',
  'umoCardView.edit': 'Edit',
  'umoCardView.edited': '(Edited)',
  'umoCardView.cancel': 'Cancel',
  'umoCardView.attachments': 'Attachments',
  'umoCardView.uploading': 'Uploading in Progress',
  'umoCardView.comments': 'Comments',
  'umoCardView.description': 'Description',
  'umoCardView.addComment': 'Add a new comment',
  'umoCardView.noAttachments': 'Nothing is attached yet',
  'umoCardView.submit': 'Submit',
  'umoCardView.uploadButton': 'Upload',
  'umoCardView.commentBy': 'Comment By {name},  ',
  'umoCardView.getCardError': 'An error occurred while getting card data',
  'umoCardView.delCommentError':
    'An error occurred while trying to delete the comment',
  'umoCardView.delAttachmentError':
    'An error occurred while trying to delete the file',
  'umoCardView.delCardError':
    'An error occurred while trying to delete the card',
  'umoCardView.delCardVerify': 'Are you sure you want to delete this card?',
  'umoCardView.delCommentUndo': 'Undo delete comment',
  'umoCardView.delFileUndo': 'Undo delete file',
  'umoCardView.undo': 'Undo',
  'umoCardView.uploadFileError':
    'An error occurred while trying to upload the file',
  'umoCardView.addCommentError':
    'An error occurred while trying to save the comment',
  'umoCardView.inCategory': 'In {catName}',
  'umoCardView.tabGeneral': 'General',
  'umoCardView.tabComments': 'Comments',
  'umoCardView.tabMetadata': 'Metadata',
  'umoCardView.updateCardError': 'An error occurred while updating the card',
  'umoCardView.tabHistory': 'History',
  'umoCardView.historyID': 'ID',
  'umoCardView.historyName': 'Name',
  'umoCardView.historyDetails': 'Details',
  'umoCardView.historyDate': 'Date',
  'umoCardView.historyNone': 'No history on asset',

  'umoGridItem.relatedItemTagLabel': 'Related Items',
  'umoGridItem.relatedItemTagDescription': 'Peer related Items',
  'umoGridItem.alternateItemTagLabel': 'Alternates',
  'umoGridItem.alternateItemTagDescription': 'Alternative images for primary',
  'umoGridItem.addToWorkspaceTooltip': 'Add to "{workspaceName}"',
  'umoGridItem.selectWorkspaceTooltip': 'No workspace is selected',
  'umoGridItem.reportImageTooltip': 'Report Media',
  'umoGridItem.shareImageTooltip': 'Share Media',
  'umoGridItem.viewMetaDataTooltip': 'View Metadata',
  'umoGridItem.viewDetailsButton': 'View Details',
  'umoGridItem.menuEditMetaData': 'Edit Metadata',
  'umoGridItem.menuCrop': 'Crop',
  'umoGridItem.menuRotate': 'Rotate',
  'umoGridItem.menuMirror': 'Mirror',
  'umoGridItem.menuImageAnnotator': 'Image Annotator',
  'umoGridItem.menuResize': 'Resize',
  'umoGridItem.menuAudioAnnotator': 'Audio Annotator',
  'umoGridItem.menuVideoAnnotator': 'Video Annotator',
  'umoGridItem.menuVideoSnippet': 'Video Snippet',
  'umoGridItem.menuViewPeers': 'View Peers',
  'umoGridItem.menuEditMeta': 'Edit Metadata',
  'umoGridItem.menuMetaPopulate': 'Media Populate',
  'umoGridItem.menuMetaCopy': 'Copy Metadata',
  'umoGridItem.menuNoDownloadsAvailableMessage': 'No downloads available',
  'umoGridItem.toolsHeader': 'Tools',
  'umoGridItem.menuDownloadsHeader': 'Downloads',
  'umoGridItem.menuRelatedImagesHeader': 'Related Images',
  'umoGridItem.menuToolsHeader': 'Tools',
  'umoGridItem.cropUnsupportedTypes':
    'Crop is not supported for .dng/.cr2/.nef/.raw file types',
  'umoGridItem.rotateUnsupportedTypes':
    'Rotate is not supported for .dng/.cr2/.nef/.raw file types',
  'umoGridItem.mirrorUnsupportedTypes':
    'Mirror is not supported for .dng/.cr2/.nef/.raw file types',
  'umoGridItem.noDerivativeAccess':
    'No derivatives available for this image',
  'umoGridItem.menuSimilarColor': 'Similar Colored Images',
  'umoGridItem.menuImageMatch': 'Matching Images',
  'umoGridItem.menuGglLandmark': 'Landmarks Recognition',
  'umoGridItem.menuGglLabels': 'Labels Recognition',
  'umoGridItem.menuGglReverse': 'Reverse Image Recognition',
  'umoGridItem.menuGglHandwriting': 'Handwriting Recognition',
  'umoGridItem.menuGglText': 'Text Recognition',
  'umoGridItem.menuAmznFacial': 'Facial Recognition',

  'umoListItem.fileName': 'File Name',
  'umoListItem.type': 'Type',
  'umoListItem.size': 'Size',
  'umoListItem.height': 'Height (px)',
  'umoListItem.width': 'Width (px)',
  'umoListItem.duration': 'Duration',
  'umoListItem.dateCreated': 'Date Loaded',

  'workspace.dropRestrictionError':
    'You cannot move items between workspaces. Only from a category to a workspace, or to a different space within the same workspace',

  'workspaceDialog.editWorkspaceHeader': 'Workspace Settings',
  'workspaceDialog.attachments': 'Attachments',
  'workspaceDialog.saveButton': 'Save',
  'workspaceDialog.addChildWorkspaceHeader': 'Add Sub-Space',
  'workspaceDialog.createButton': 'Create',
  'workspaceDialog.addWorkspaceHeader': 'Add Workspace',
  'workspaceDialog.shareLabel': 'Share:',
  'workspaceDialog.sharePlaceholder':
    'Select users to share your workspace with',
  'workspaceDialog.shareRemoveAll': 'Remove all',
  'workspaceDialog.nameLabel': 'Name:',
  'workspaceDialog.namePlaceholder': 'Enter Workspace Name',
  'workspaceDialog.descriptionLabel': 'Description:',
  'workspaceDialog.descriptionPlaceholder': 'Enter Workspace Description',
  'workspaceDialog.expiryLabel': 'Expiry Date:',
  'workspaceDialog.sharingSecurityLabel': 'Sharing Security:',
  'workspaceDialog.sharingSecurityCheckbox': 'Public | Secure',
  'workspaceDialog.sharingSecurityHelper':
    'Public mode allows users to view all assets in the workspace.\n\nSecure mode allows users to only view assets they already have access to',
  'workspaceDialog.ownerLabel': 'Workspace Owner:',
  'workspaceDialog.cancelButton': 'Cancel',
  'workspaceDialog.deleteButton': 'Delete',
  'workspaceDialog.deleteWorkspace':
    'Deleting this workspace will delete all sub workspaces as well.  This process may take a few moments to complete.',
  'workspaceDialog.deleteSuccess': 'Workspace deleted Successfully',
  'workspaceDialog.unsubscribeButton': 'Unsubscribe',
  'workspaceDialog.unsubscribeFromWS':
    'Are you sure you want to unsubscribe from this workspace?',
  'workspaceDialog.unsubscribeSuccess':
    'You have been successfully unsubscribed from this workspace',
  'workspaceDialog.nameExists': 'A Workspace with the same name already exists',
  'workspaceDialog.errorOccurred':
    'An Error has occurred while saving your workspace',
  'workspaceDialog.downloadRuleList': 'External Users Download Rule:',
  'workspaceDialog.downloadRuleListHelper':
    'Select a download rule to be used for portal users',
  'workspaceDialog.downloadRuleListEmpty':
    'No External Download Rules to display.',
  'workspaceDialog.downloadRuleSetting': 'Download Setting:',
  'workspaceDialog.downloadRuleSettingHelper':
    'Please refer to workspace owner in order to change the available download derivatives',

  'mainDialog.title': 'Share Links',
  'mainDialog.subTitle': 'Share media item {umoName}',
  'mainDialog.copy': 'Copied',
  'mainDialog.copyTooltip': 'Copy to Clipboard',

  'highlightSetDialog.editWorkspaceHeader': 'Edit Curated Set',
  'highlightSetDialog.addWorkspaceHeader': 'Add Curated Set',
  'highlightSetDialog.namePlaceholder': 'Enter Set Name',
  'highlightSetDialog.deleteSuccess': 'Set deleted Successfully',
  'highlightSetDialog.nameExists': 'A Set with the same name already exists',
  'highlightSetDialog.errorOccurred':
    'An Error has occurred while saving your set',

  'workspaceEmailDialog.emailSentSuccessMessage': 'Email successfully sent',
  'workspaceEmailDialog.emailWorkspaceHeader': 'Email Workspace',
  'workspaceEmailDialog.emailWorkspaceSubtext':
    'Use this form to email the contents of this workspace.',
  'workspaceEmailDialog.emailWorkspacePortal':
    'Use this form to create a temporary account with access to this workspace.',
  'workspaceEmailDialog.namePlaceholder': 'Your Name',
  'workspaceEmailDialog.accountNamePlaceholder': 'Account Name',
  'workspaceEmailDialog.toEmailPlaceholder': 'To Email Address',
  'workspaceEmailDialog.toEmailSubtext':
    'Use a comma or semi-colon to separate multiple emails.',
  'workspaceEmailDialog.messagePlaceholder': 'Message',
  'workspaceEmailDialog.cancelButton': 'Cancel',
  'workspaceEmailDialog.sendButton': 'Send',
  'workspaceEmailDialog.DMZMessage':
    'It might take a few minutes for all items to appear in the DMZ workspace',

  'workspaceResizeDialog.mainTitle': 'Resize Images',
  'workspaceResizeDialog.optionsTitle': 'Resize Options',
  'workspaceResizeDialog.optionsType': 'Type',
  'workspaceResizeDialog.optionsWidth': 'Width',
  'workspaceResizeDialog.optionsDPI': 'DPI',
  'workspaceResizeDialog.optionsQuality': 'Quality',
  'workspaceResizeDialog.optionsEmbedMetadata': 'Embed XMP Metadata',
  'umoModifyDialog.buttonCancel': 'Cancel',
  'umoModifyDialog.buttonApply': 'Apply',
  'umoModifyDialog.tabResize': 'Resize',
  'umoModifyDialog.tabCrop': 'Crop',
  'umoModifyDialog.tabCopy': 'Copy',
  'umoModifyDialog.tabRotate': 'Rotate',
  'umoModifyDialog.inProgressMessage':
    'This process may take some time and will continue in the background',
  'workspaceDownloadDialog.buttonDownload': 'Download',
  'workspaceDownloadDialog.autoEmailDownload':
    'This item is being generated in the background and will be sent to your email address',
  'workspaceDownloadDialog.emailDownload':
    'This item will be sent to the email address you have provided',
  'workspaceDownloadDialog.emailDynamicDownload':
    'This item is dynamically generated and will be sent to the email address you provide',
  'workspaceDownloadDialog.mainTitle': 'Download Media',
  'workspaceDownloadDialog.optionsTitle':
    'Download the contents of the workspace to a zip file',
  'workspaceDownloadDialog.pdfDownloadTitle':
    'Generate a PDF with the contents of the workspace',
  'workspaceDownloadDialog.optionsSubTitle':
    'Select the derivative for each type of media',
  'workspaceDownloadDialog.optionsPhoto': 'Photo',
  'workspaceDownloadDialog.optionsVideo': 'Video',
  'workspaceDownloadDialog.optionsAudio': 'Audio',
  'workspaceDownloadDialog.optionsDocuments': 'Documents',
  'workspaceDownloadDialog.optionsItemsPerPage':
    'Select number of items per page.',

  'workspacePreview.workspaceDetailsButton': 'Workspace Details',
  'workspacePreview.options': 'Options',
  'workspacePreview.selection': 'Selection',
  'workspacePreview.selection.selectAll': 'Select All',
  'workspacePreview.selection.deselectAll': 'Deselect All',
  'workspacePreview.actions': 'Actions',
  'workspacePreview.actions.removeSelectedFromWorkspace':
    'Remove Selected from Workspace',

  'utils.piction.moveCategoryGenericError':
    'An error has occurred, please try again.',
  'utils.piction.moveCategoryPermissionError':
    'You do not have permissions to move items into the selected category',

  'metadataView.noMetadata':
    'There is no metadata available for the selected umo',

  'newRelational.addNewRelational': 'Add New Record',
  'newRelational.configErr': 'Configuration Error.',
  'newRelational.contactAdminMsg':
    'Contact your system admin to use this feature',
  'highlight.curated.sets': 'Curated Sets',

  'fileUploader.title': 'Piction File Uploader',
  'fileUploader.subTitle': 'Upload multiple files. Drag/drop your files below.',
  'fileUploader.uploadToCategoryLabel': 'Upload to Category: ',
  'fileUploader.dropAreaLabel': 'Drop here',
  'fileUploader.browseOrDropLabel': 'Click to browse or Drop here',
  'fileUploader.addMoreLabel': 'Add more',
  'fileUploader.addMetadata': 'Add Metadata',
  'fileUploader.fileList': 'File List',
  'fileUploader.itemsSelected': ' selected',
  'fileUploader.loadingLabel': 'Loading',
  'fileUploader.uploadingLabel': 'Uploading',
  'fileUploader.processingLabel': 'Processing files',
  'fileUploader.waitLabel': ', please wait',
  'fileUploader.fileUploadFail': 'Failed to upload file',
  'fileUploader.fileUploadFailFor': 'File upload failed for: {filename}',
  'fileUploader.fileUploadSuccess': ' successfully uploaded',
  'fileUploader.fileUploadPause': 'File upload stopped/paused for: {filename}',
  'fileUploader.nameExists':
    'Upload failed, file with the name {name} already exists',
  'fileUploader.maxFilesExceeded':
    'You have exceeded the maximum number of files allowed. You can only upload up to {maxCount} files.',
  'fileUploader.maxTotalFileSize':
    'Max total file size of {filesize} exceeded, please remove some files',
  'fileUploader.maxFilesize': 'Max file size',
  'fileUploader.invalidType': 'The file {fileName} is of an invalid type',
  'fileUploader.supportedFileTypes': 'Supported file types: ',
  'fileUploader.copyRowDown': 'Copy this row downwards',
  'fileUploader.copyRowUp': 'Copy this row upwards',
  'fileUploader.copyRowToRows': 'Copy this row to other rows',
  'fileUploader.copyCellDown': 'Copy this cell downwards',
  'fileUploader.copyCellUp': 'Copy this cell upwards',
  'fileUploader.copyCellToCell': 'Copy this cell to other cells',
  'fileUploader.metaUpdateSuccess': 'Metadata updated successfully',
  'fileUploader.metaUpdateFail': 'Failed to update metadata',
  'fileUploader.uploadInProgressMessage':
    'Upload in progress. Try again later.',
  'fileUploader.requiredMetadataMsg': 'This field is required.',
  'fileUploader.requiredMetadataError': 'Please fill in the mandatory fields.',

  'fileLoadingIndicator.uploads': 'Uploads',
  'fileLoadingIndicator.uploadComplete': 'Upload Process Completed',
  'fileLoadingIndicator.uploading': 'Uploading',
  'fileLoadingIndicator.pleaseWait': 'Please wait, this may take some time.',
  'fileLoadingIndicator.pleaseReview':
    "Please take a moment to review each file to ensure they've all uploaded successfully.",
  'fileLoadingIndicator.filterAll': 'All',
  'fileLoadingIndicator.filterQueued': 'Queued',
  'fileLoadingIndicator.filterUploading': 'Uploading',
  'fileLoadingIndicator.filterUploaded': 'Uploaded',
  'fileLoadingIndicator.filterFailed': 'Failed',
  'fileLoadingIndicator.filterDuplicated': 'Duplicated',
  'fileLoadingIndicator.noFilesFound':
    'No files found for the selected filter.',

  'metaInput.newEntry': 'New entry',
  'metaInput.addNewEntry': 'Add new entry',
  'metaInput.addNewRGroupEntry': 'Add new entry for {name}',
  'metaInput.existingEntries': 'Existing Entries',
  'metaInput.editField': 'Edit Field',
  'metaInput.entryNum': 'Entry #{number}',
  'metaInput.updateIndividually': 'Update Individually',
  'metaInput.bulkUpdate': 'Bulk Update',

  'imageEdit.rotateImage': 'Rotate Image',
  'imageEdit.mirrorImage': 'Mirror Image',
  'imageEdit.rotateImageSuccess': 'Succcessfully created new UMO',
};
